import { Banner } from "../Model/Banner";
import { OffersPromoRepository } from "../Repository/OffersPromoRepository";

export interface CreateBannerUseCase {
  invoke: (data: Banner) => Promise<boolean>;
}

export class CreateBanner implements CreateBannerUseCase {

  private Repo: OffersPromoRepository;

  constructor(_Repo: OffersPromoRepository) {
    this.Repo = _Repo;
  }

  async invoke(data: Banner){

    if(!data){
        throw new Error(
            "Your todo should have at leat 2 characters."
          );
    }
     
    const created  = await this.Repo.createBanner(data);
    return created;
  }
}